var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8281 14.9996H2.69013C1.75667 14.9996 1.00047 14.2435 1.00047 13.31V4.90975L3.23606 0.999649H12.2822L14.5178 4.90975V13.31C14.5178 13.7579 14.3396 14.1878 14.0228 14.5046C13.706 14.8214 13.276 14.9996 12.8282 14.9996H12.8281ZM2.44875 5.29644V13.31C2.44875 13.3741 2.47421 13.4354 2.51947 13.4807C2.56472 13.5259 2.62601 13.5514 2.69013 13.5514H12.8281C12.8922 13.5514 12.9535 13.5259 12.9987 13.4807C13.044 13.4354 13.0694 13.3741 13.0694 13.31V5.29644L11.443 2.44792H4.07533L2.44875 5.29644Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89377 8.48199H5.62063L4.65511 6.55096H2.2056V5.10268H5.54918L6.5147 7.03372H9.00018L9.9657 5.10268H14.2748V6.55096H10.8598L9.89377 8.48199Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.09b756e4c9bba2c429b4c348bf31fce6.svg";
export { ForwardRef as ReactComponent };